const SIGNUP_ONBOARDING_KEY = 'signupOnboarding';
const SIGNUP_NICKNAME_KEY = 'signupNickname';

export function markSignupOnboarding() {
  localStorage.setItem(SIGNUP_ONBOARDING_KEY, '1');
}

export function clearSignupOnboarding() {
  localStorage.removeItem(SIGNUP_ONBOARDING_KEY);
  localStorage.removeItem(SIGNUP_NICKNAME_KEY);
}

export function isSignupOnboarding() {
  return localStorage.getItem(SIGNUP_ONBOARDING_KEY) === '1';
}

export function setSignupNickname(nickname) {
  localStorage.setItem(SIGNUP_NICKNAME_KEY, nickname);
}

export function getSignupNickname() {
  return localStorage.getItem(SIGNUP_NICKNAME_KEY) || '';
}
